import { useState, useEffect } from 'react';
import type { Event } from '@/types/calendar';

export function useEvents() {
  const [ events, setEvents ] = useState<Event[]>([]);
  const [ isLoading, setIsLoading ] = useState(true);
  const [ error, setError ] = useState<Error | null>(null);

  useEffect(() => {
    async function fetchEvents() {
      try {
        setIsLoading(true);
        const response = await fetch(`${window.curtisCalendar.apiurl}/events`);

        if (!response.ok) {
          throw new Error('Failed to fetch events');
        }

        const json = await response.json();

        if (!json.success) {
          throw new Error('Failed to fetch events');
        }

        setEvents(json.data);
      } catch (err) {
        setError(err instanceof Error ? err : new Error('An unknown error occurred'));
      } finally {
        setIsLoading(false);
      }
    }

    fetchEvents();
  }, []);

  return { events, isLoading, error };
}
